var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrevious = function SvgPrevious(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6777FF",
    d: "M14.741 16.742c-.475 0-.941-.125-1.375-.375l-6.908-3.984A2.74 2.74 0 0 1 5.083 10c0-.992.517-1.883 1.375-2.383l6.908-3.984c.859-.5 1.884-.5 2.75 0a2.71 2.71 0 0 1 1.375 2.384v7.975c0 .991-.516 1.883-1.375 2.383a2.8 2.8 0 0 1-1.375.367m0-12.234a1.5 1.5 0 0 0-.75.2L7.083 8.692c-.467.275-.75.758-.75 1.3 0 .541.283 1.025.75 1.3l6.908 3.983a1.47 1.47 0 0 0 1.5 0c.467-.275.75-.758.75-1.3V6c0-.542-.283-1.025-.75-1.3a1.7 1.7 0 0 0-.75-.192M3.133 15.775a.63.63 0 0 1-.625-.625V4.85a.63.63 0 0 1 .625-.625.63.63 0 0 1 .625.625v10.3a.63.63 0 0 1-.625.625"
  })));
};
export default SvgPrevious;